import React from 'react';
import { Modal } from 'antd';
import { useShutdownResponsibleChange } from '../../../../api';
import { getTooltipTitleForWorker } from '../../../../../../../shared/lib/utils';
import Item from '../Item/Item';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
  notificationSendingAlertTypes,
} from '../../../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';

const { confirm } = Modal;

const DeleteEntity = ({ shutdown, item, parentWidth }) => {
  const { change } = useShutdownResponsibleChange();

  const handleClick = (e) => {
    e.stopPropagation();

    confirm({
      title: `Удалить ответственного ${getTooltipTitleForWorker(item)}?`,
      content: (
        <NotificationSendingAlert
          alertType={notificationSendingAlertTypes.text}
          messageType={notificationSendingAlertMsgTypes.worker}
        />
      ),
      onOk: async () =>
        await change({
          shutdownId: shutdown.alertId,
          data: shutdown.executors
            .filter((i) => i.id !== item.id)
            .map((i) => ({ id: i.id })),
        }),
      onCancel: () => {},
    });
  };

  return (
    <Item
      item={item}
      onClick={handleClick}
      additionalTooltipTitle="Удалить"
      parentWidth={parentWidth}
    />
  );
};

export default DeleteEntity;
